import styled from "styled-components";
import {Text5} from "../../Common/index";
import BulletTickImage from "../../../Assets/check.png";
export const PricingCardWrapper = styled.div`
    width : 100%;
    max-width : 300px;
    background-color: ${props=>props.backgroundColor || '#262636'};
    display: flex;
    flex-direction: column;
    padding: ${props=>props.padding || '20px'};
    border-radius : 10px ; 
    gap : 10px ; 

`

export const StarterText = styled(Text5)`
  background: linear-gradient(180deg, #06d9ca 29.53%, #00ff85 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: ${props=>props.fontSize};
`;

export const ProText = styled(Text5)`
  background: linear-gradient(180deg, #19b6f0 29.53%, #4285f4 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: ${(props) => props.fontSize};
`;


export const BossModeText = styled(Text5)`
  background: linear-gradient(180deg, #f045d1 0%, #fd155f 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: ${(props) => props.fontSize};
`;

export const FeatureList = styled.ul `
  list-style-image: url(${BulletTickImage});
  margin : ${props=>props.margin || "15px auto"};
`
export const BossModeExtraDiv = styled.div`
  background-color: #641878;
  height: 60px;
  display: block;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

export const BossModeButton = styled.button`
  width: ${(props) => props.width || "150px"};
  height: ${(props) => props.height || "50px"};
  background-color: ${(props) => props.backgroundColor || "transparent"};
  color: ${(props) => props.color || "#FFF"};
  font-size: ${(props) => props.fontSize || "1.5rem"};
  margin: ${(props) => props.margin || "0 auto"};
  border: 5px solid transparent;
  /* border-radius: 20px; */
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(90deg, #F045D1 0%, #FD155F 100%) ; 
  @media screen and (max-width: 768px) {
    font-size: 1rem;
    max-width: 200px;
  }
  ${(props) =>
    props.borderImage && `border-image-source : ${props.borderImage}`}

  border-radius: 8px;
  -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
`;